export default __webpack_public_path__ + "static/media/chat.9d514f76.svg";